import "isomorphic-fetch";

if (!window.crypto) window.crypto = window.msCrypto;
